<template>
  <div class="headlines">
    <div>
      <p>{{ $t(`${$route.name}.docNumber`) }}</p>
    </div>
    <div>
      <p>{{ $t(`${$route.name}.productionDate`) }}</p>
    </div>
    <div v-if="$route.name !== 'returncustdocs'">
      <p>{{ $t(`${$route.name}.dueDate`) }}</p>
    </div>
    <div v-if="$route.name === 'orders'">
      <p>{{ $t("orders.reference") }}</p>
    </div>
    <div>
      <p>{{ $t(`${$route.name}.status`) }}</p>
    </div>
    <div v-if="$route.name === 'returncustdocs'">
      <p>{{ $t(`${$route.name}.returnDocStatus`) }}</p>
    </div>
    <div>
      <p>{{ $t(`${$route.name}.sum`) }}</p>
    </div>
    <div v-if="$route.name === 'adminPanel'">
      <p>{{ $t(`${$route.name}.action`) }}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.headlines {
  display: flex;
  padding: 0 15px;
  gap: 10px;
  white-space: nowrap;
  justify-content: space-between;

  div {
    min-width: 120px;
    flex: 1;
  }

  p {
    font-size: $mediumTextSize;
    font-weight: 500;
    line-height: 21.33px;
    text-align: right;
    width: fit-content;
  }
}

@media only screen and (max-width: 601px) {
  .headlines {
    div {
      padding-right: 20px;
    }
  }
}
</style>
